module.exports = __webpack_public_path__ + "static/media/can_logo.0ac0983b.png";